// extracted by mini-css-extract-plugin
export var content = "press-module--content--57e02";
export var event = "press-module--event--ccd0c";
export var link = "press-module--link--a2880";
export var row = "press-module--row--4746a";
export var section = "press-module--section--2b0d4";
export var sidebar = "press-module--sidebar--7e99a";